import { render } from "./lySystemLogs.vue?vue&type=template&id=6b6ad4ac"
import script from "./lySystemLogs.vue?vue&type=script&lang=js"
export * from "./lySystemLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__